import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/be/501/',
    component: ComponentCreator('/be/501/', '272'),
    exact: true
  },
  {
    path: '/be/articles/',
    component: ComponentCreator('/be/articles/', 'edb'),
    exact: true
  },
  {
    path: '/be/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/be/articles/2024/07/09/diskusija-lj-nj-cyrl/', '76a'),
    exact: true
  },
  {
    path: '/be/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/be/articles/2024/07/09/diskusija-lj-nj/', '9d9'),
    exact: true
  },
  {
    path: '/be/articles/archive/',
    component: ComponentCreator('/be/articles/archive/', '010'),
    exact: true
  },
  {
    path: '/be/articles/authors/',
    component: ComponentCreator('/be/articles/authors/', '4c4'),
    exact: true
  },
  {
    path: '/be/search/',
    component: ComponentCreator('/be/search/', 'fa4'),
    exact: true
  },
  {
    path: '/be/',
    component: ComponentCreator('/be/', '959'),
    exact: true
  },
  {
    path: '/be/',
    component: ComponentCreator('/be/', 'a96'),
    routes: [
      {
        path: '/be/',
        component: ComponentCreator('/be/', 'bdd'),
        routes: [
          {
            path: '/be/tags/',
            component: ComponentCreator('/be/tags/', '381'),
            exact: true
          },
          {
            path: '/be/tags/comparative/',
            component: ComponentCreator('/be/tags/comparative/', 'aa2'),
            exact: true
          },
          {
            path: '/be/tags/grammar/',
            component: ComponentCreator('/be/tags/grammar/', '3c5'),
            exact: true
          },
          {
            path: '/be/tags/interslavic/',
            component: ComponentCreator('/be/tags/interslavic/', 'eee'),
            exact: true
          },
          {
            path: '/be/tags/language-learning/',
            component: ComponentCreator('/be/tags/language-learning/', '349'),
            exact: true
          },
          {
            path: '/be/tags/linguistics/',
            component: ComponentCreator('/be/tags/linguistics/', 'eff'),
            exact: true
          },
          {
            path: '/be/tags/personal-pronouns/',
            component: ComponentCreator('/be/tags/personal-pronouns/', '2fa'),
            exact: true
          },
          {
            path: '/be/tags/pronouns/',
            component: ComponentCreator('/be/tags/pronouns/', 'be8'),
            exact: true
          },
          {
            path: '/be/tags/slavic-languages/',
            component: ComponentCreator('/be/tags/slavic-languages/', '61c'),
            exact: true
          },
          {
            path: '/be/tags/вывучэнне-мовы/',
            component: ComponentCreator('/be/tags/вывучэнне-мовы/', '9a7'),
            exact: true
          },
          {
            path: '/be/tags/граматыка/',
            component: ComponentCreator('/be/tags/граматыка/', 'faa'),
            exact: true
          },
          {
            path: '/be/tags/займеннікі/',
            component: ComponentCreator('/be/tags/займеннікі/', 'f27'),
            exact: true
          },
          {
            path: '/be/tags/міжславянская-мова/',
            component: ComponentCreator('/be/tags/міжславянская-мова/', '055'),
            exact: true
          },
          {
            path: '/be/tags/міжславянская/',
            component: ComponentCreator('/be/tags/міжславянская/', 'e26'),
            exact: true
          },
          {
            path: '/be/tags/параўнанне-моў/',
            component: ComponentCreator('/be/tags/параўнанне-моў/', '3a5'),
            exact: true
          },
          {
            path: '/be/',
            component: ComponentCreator('/be/', '617'),
            routes: [
              {
                path: '/be/learn/faq/',
                component: ComponentCreator('/be/learn/faq/', 'ca5'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/',
                component: ComponentCreator('/be/learn/grammar/', 'b2a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/adjectives/',
                component: ComponentCreator('/be/learn/grammar/adjectives/', '2cf'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/conjunctions/',
                component: ComponentCreator('/be/learn/grammar/conjunctions/', '1b9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/nouns/',
                component: ComponentCreator('/be/learn/grammar/nouns/', 'b38'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/numerals/',
                component: ComponentCreator('/be/learn/grammar/numerals/', 'f09'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/prepositions/',
                component: ComponentCreator('/be/learn/grammar/prepositions/', '577'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/pronouns/',
                component: ComponentCreator('/be/learn/grammar/pronouns/', '706'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/syntax/',
                component: ComponentCreator('/be/learn/grammar/syntax/', 'e06'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/grammar/verbs/',
                component: ComponentCreator('/be/learn/grammar/verbs/', 'cce'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/introduction/',
                component: ComponentCreator('/be/learn/introduction/', 'bc0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/be/learn/misc/constructed-slavic-languages/', 'cfe'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/misc/design-criteria/',
                component: ComponentCreator('/be/learn/misc/design-criteria/', '851'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/misc/history/',
                component: ComponentCreator('/be/learn/misc/history/', '98d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/misc/language-comparison/',
                component: ComponentCreator('/be/learn/misc/language-comparison/', 'ea0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/misc/numbers-1-10/',
                component: ComponentCreator('/be/learn/misc/numbers-1-10/', '243'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/be/learn/misc/pan-slavic-relay/', 'b49'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/misc/personal-pronouns/',
                component: ComponentCreator('/be/learn/misc/personal-pronouns/', '5b4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/orthography/',
                component: ComponentCreator('/be/learn/orthography/', '307'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/phonology/',
                component: ComponentCreator('/be/learn/phonology/', '552'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/pronunciation/',
                component: ComponentCreator('/be/learn/pronunciation/', '74b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/simple-grammar/',
                component: ComponentCreator('/be/learn/simple-grammar/', 'eb1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/simple-grammar/level-1/',
                component: ComponentCreator('/be/learn/simple-grammar/level-1/', '03d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/simple-grammar/level-2/',
                component: ComponentCreator('/be/learn/simple-grammar/level-2/', 'c7f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/vocabulary/derivation/',
                component: ComponentCreator('/be/learn/vocabulary/derivation/', '739'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/be/learn/vocabulary/flavourisation/', 'a27'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/learn/vocabulary/word-formation/',
                component: ComponentCreator('/be/learn/vocabulary/word-formation/', 'f70'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/be/resources/',
                component: ComponentCreator('/be/resources/', '547'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/be/resources/applets/',
                component: ComponentCreator('/be/resources/applets/', '25c'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/be/resources/applets/intelligibility/',
                component: ComponentCreator('/be/resources/applets/intelligibility/', '630'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/be/resources/applets/transliterator/',
                component: ComponentCreator('/be/resources/applets/transliterator/', '178'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/be/resources/keyboards/',
                component: ComponentCreator('/be/resources/keyboards/', 'd2a'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
